// removed by extract-text-webpack-plugin
module.exports = {"buttons":"order-manager-filter__buttons-2oQhW","button":"order-manager-filter__button-3i4XN","label":"order-manager-filter__label-1Tk2C","radio":"order-manager-filter__radio-DH3B6"};


//////////////////
// WEBPACK FOOTER
// ./components/account/orders/orders-navigation/order-manager-collapser/order-manager-filter/order-manager-filter.css
// module id = 770
// module chunks = 0